<svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
<path d="M12 1C10.915 1 10.0537 1.91338 10.1174 2.99655L10.9413 17.0017C10.9743 17.5623 11.4385 18 12 18C12.5615 18 13.0257 17.5623 13.0587 17.0017L13.8826 2.99655C13.9463 1.91338 13.085 1 12 1Z" fill="current"/>
<path d="M12 23C13.1046 23 14 22.1046 14 21C14 19.8954 13.1046 19 12 19C10.8954 19 10 19.8954 10 21C10 22.1046 10.8954 23 12 23Z" fill="current"/>
</svg>
